import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient } from '../../core/api-client.service';
import { DumbDashboardInfo } from './DTOs/dumb-dashboard-info';

@Injectable({
  providedIn: 'root'
})
export class MemberDashboardService {

  readonly relativeBase = "member-admin-dashboard/";


  constructor(private http: ApiClient) {

  }

  getDashboardInfo(): Observable<DumbDashboardInfo> {
    return this.http.get(this.relativeBase + "info");
  }
}
